;(function () {
  angular
    .module('contrast.org-stats')
    .controller('OrgStatsServersCtrl', OrgStatsServersCtrl)

  function OrgStatsServersCtrl(
    $location,
    $translate,
    OrgStatsService,
    PromiseService,
    ErrorService,
    LoadFilterRouteService,
    UserService,
    ServerFactory,
    LicenseFactory,
    ORG_STATS_CONSTANTS,
    SERVER_ENVIRONMENT_SELECT,
    QUICK_FILTERS
  ) {
    'ngInject'

    var vm = this
    var quickFiltersPromise

    var translGlobal = {
      title_all_servers: $translate.instant('title_all_servers'),
      title_serversNearingExpiration: $translate.instant(
        'title_serversNearingExpiration'
      )
    }

    angular.extend(vm, {
      servers: {
        breakdown: {},
        donutConfig: {},
        showMoreLimit: 5
      },
      filters: {
        environments: SERVER_ENVIRONMENT_SELECT,
        environment: SERVER_ENVIRONMENT_SELECT[0],
        quickFilters: [],
        selectedQuickFilter: {
          name: translGlobal.title_all_servers,
          filterType: 'ALL',
          count: '?'
        }
      },
      loading: {
        stats: true,
        breakdown: true
      },
      model: {
        protection: {
          servers: [],
          limit: 3
        }
      }
    })

    angular.extend(vm, {
      onEnvironmentChange: onEnvironmentChange,
      onQuickFilterSelect: onQuickFilterSelect,
      hasServers: hasServers,
      onServerCountClick: LoadFilterRouteService.goToFilteredServers,
      onProtectClick: _getFilterServersRouteFn(
        QUICK_FILTERS.SERVERS.PROTECTED.KEY
      ),
      onOnlineClick: _getFilterServersRouteFn(QUICK_FILTERS.SERVERS.ONLINE.KEY),
      showMoreOnboarded: showMoreOnboarded,
      showAllServersNearingExpiration: showAllServersNearingExpiration
    })

    function init() {
      _getServerStats()
      _getServerStatsBreakdown()
      _getQuickFilters()
      _loadUpcomingProtectionExpiredLicenses()
    }

    function onEnvironmentChange() {
      _getServerStatsBreakdown()
    }

    function onQuickFilterSelect(filter) {
      vm.filters.selectedQuickFilter = filter
      _getServerStats()
      _getServerStatsBreakdown()
    }

    function hasServers() {
      return vm.servers.deployed !== 0
    }

    function showMoreOnboarded(title) {
      var expand = [ORG_STATS_CONSTANTS.SERVER_EXPAND.ONBOARDED]

      vm.loading.stats = true
      OrgStatsService.getServerStats(
        expand,
        vm.filters.selectedQuickFilter.filterType,
        undefined
      )
        .then(function (stats) {
          OrgStatsService.openShowMoreModal(
            stats.onboarded,
            title,
            _goToServerOverview
          )
        })
        .finally(function () {
          vm.loading.stats = false
        })
    }

    function _goToServerOverview(server) {
      $location.path(
        UserService.buildUrl(/servers/ + server.server_id + '/overview')
      )
    }

    function _getServerStats() {
      var expand = [
        ORG_STATS_CONSTANTS.SERVER_EXPAND.OFFLINE,
        ORG_STATS_CONSTANTS.SERVER_EXPAND.DELETED,
        ORG_STATS_CONSTANTS.SERVER_EXPAND.ONBOARDED
      ]

      vm.loading.stats = true
      vm.loading.statsPromise = OrgStatsService.getServerStats(
        expand,
        vm.filters.selectedQuickFilter.filterType,
        vm.servers.showMoreLimit
      )
        .then(function (stats) {
          vm.servers.thermometerConfig = stats.thermometerConfig
          vm.servers.deployed = stats.deployed
          vm.servers.deleted = stats.deleted
          vm.servers.onboarded = stats.onboarded
          vm.servers.offline = stats.offline
          vm.servers.deletedCount = stats.deletedCount
          vm.servers.onboardedCount = stats.onboardedCount
          vm.servers.offlineCount = stats.offlineCount
        })
        .finally(function () {
          vm.loading.stats = false
        })
    }

    function _getServerStatsBreakdown() {
      var expand = [ORG_STATS_CONSTANTS.SERVER_BREAKDOWNS.CONTAINERS]

      vm.loading.breakdown = true
      vm.loading.breakdownPromise = OrgStatsService.getServerStatsBreakdown(
        expand,
        vm.filters.selectedQuickFilter.filterType,
        vm.filters.environment.value,
        [ORG_STATS_CONSTANTS.SERVER_BREAKDOWNS.CONTAINERS]
      )
        .then(function (stats) {
          vm.servers.donutConfig = stats.donutConfig
          vm.servers.breakdown = stats.breakdown
        })
        .finally(function () {
          vm.loading.breakdown = false
        })
    }

    function _getQuickFilters() {
      if (quickFiltersPromise) {
        PromiseService.cancelPromise(quickFiltersPromise)
      }

      var filters = {
        includeArchived: false
      }

      quickFiltersPromise = ServerFactory.getServersQuickFilters(filters)

      quickFiltersPromise
        .then(function (response) {
          vm.filters.quickFilters = response.data.filters

          vm.filters.selectedQuickFilter = vm.filters.quickFilters.find(
            function (filter) {
              return (
                filter.filterType === vm.filters.selectedQuickFilter.filterType
              )
            }
          )
        })
        .catch(ErrorService.processError)

      return quickFiltersPromise
    }

    function _getFilterServersRouteFn(quickFilter) {
      return function (environment) {
        LoadFilterRouteService.goToFilteredServers(quickFilter, environment)
      }
    }

    function _loadUpcomingProtectionExpiredLicenses() {
      LicenseFactory.getUpcomingProtectionExpiredLicenses()
        .then(function (response) {
          vm.model.protection.servers = response.data.servers
        })
        .catch(ErrorService.processError)
    }

    function showAllServersNearingExpiration() {
      OrgStatsService.openShowMoreModal(
        vm.model.protection.servers,
        translGlobal.title_serversNearingExpiration,
        _goToServerOverview
      )
    }

    init()
  }
})()
